export default class BlockTextImageCarousel {

  init() {
    this.swiper = new Swiper(this.outlets.swiper, {
      loop: true,
      navigation: {
        nextEl: this.outlets.next,
        prevEl: this.outlets.prev
      },
      pagination: {
        el: this.outlets.pagination
      }
    });
  }

}
